import {axiosApi} from './helper'

// Création de compte
export function splashscreen(){
  return axiosApi('splashscreen', {}, 'get', {}, {ispublic: true})
}

export function getLocales() {
  return axiosApi('locales', {}, 'get', {}, {ispublic: true})
}
